import { BlockNoteEditor, DefaultBlockSchema } from '@blocknote/core';
import { EVENT_TYPES, dispatchEvent } from './events';
import { TextHighlight } from './AiResponseHandler';

// 전역 에디터 인스턴스 저장소
let globalEditorInstance: BlockNoteEditor<DefaultBlockSchema> | null = null;

// 전역 에디터 인스턴스 설정
export const setGlobalEditorInstance = (editor: BlockNoteEditor<DefaultBlockSchema> | null) => {
  globalEditorInstance = editor;
};

// 전역 에디터 인스턴스 가져오기
export const getGlobalEditorInstance = (): BlockNoteEditor<DefaultBlockSchema> | null => {
  return globalEditorInstance;
};

// AI 응답 핸들러 트리거 함수
export const triggerAiResponseHandler = (
  editor: BlockNoteEditor<DefaultBlockSchema>,
  response: string,
  isSelectedPart: boolean = false,
  selectedMarkdown?: string,
  fullDocument?: string,
  highlightedText?: TextHighlight | null
) => {
  // 이벤트 발생시키기
  dispatchEvent(EVENT_TYPES.TRIGGER_AI_RESPONSE_HANDLER, {
    editor,
    response,
    isSelectedPart,
    selectedMarkdown,
    fullDocument,
    highlightedText
  });
};

// 윈도우 객체에 함수 등록
if (typeof window !== 'undefined') {
  window.triggerAiResponseHandler = triggerAiResponseHandler;
}

// 서비스 초기화 함수
export const initAiResponseHandlerService = () => {
  console.log('AiResponseHandlerService initialized');
};

// 서비스 초기화
initAiResponseHandlerService();

export default {
  triggerAiResponseHandler,
  setGlobalEditorInstance,
  getGlobalEditorInstance
};
